<template>
	<div>
		<v-card>
			<v-container>
				<v-row>
					<v-col cols="4" lg="4" md="4">
						<s-select-definition
							label="Area"
							v-model="TypeArea"
							:def="1281"
							:dgr="40"							
							@change="getTypeArea(TypeArea)"
						></s-select-definition>
					</v-col>
					
					<v-col cols="4" lg="4" md="4">
						<s-select-definition
							:dgr="dgr"
							label="Linea Empaque"
							:def="1315"
							v-model="TypeLineProcess"
							:add="$fun.isAdmin()"
							>
						</s-select-definition>
					</v-col>
					<v-col cols="4" lg="4" md="4">
                        <s-select-definition
                            :def="1266"
                            label="Calibres"
                            v-model="TypeCaliber">
                        </s-select-definition>
                    </v-col>
				</v-row>
				<v-row>
					<v-col cols="4" lg="4" md="4">
						<s-select-definition
							label="Faja"
							:def="1472"
							v-model="TypeFaja"
							>
						</s-select-definition>
					</v-col>
					<v-col cols="8" lg="8" md="8">
						<s-select
							:items="itemsPresentation"
							item-value="PrcID"
							full
							autocomplete
							item-text="PresentationName"
							label="Seleccione una Presentación"
							v-model="PrcID"
							@input="inputPresentation($event)"
							clearable
						></s-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="4" lg="4" md="4">
                    	<s-select
                    	label="Turno de Produccion"
                    	:items="itemTurn"
                    	item-value="TrnID"
                    	item-text="TnrObservation"
                    	v-model="processInitial.TrnID"
                    	>  
                    	</s-select>
                    </v-col>
				</v-row>
				<v-row>
					<v-col cols="12" lg="12">
						<s-text 
							label="Código" 
							@keyupEnter="keyupEnter()" 
							@input="input($event)" 
							v-model="CbpCode"
							ref="stext"
							clearable
							:disabled="isProcessing"
						></s-text>
					</v-col>
				</v-row>
				
				<!-- Indicador de procesamiento -->
				<v-row v-if="isProcessing">
					<v-col cols="12" class="text-center">
						<v-progress-circular
							indeterminate
							color="primary"
							:size="40"
						></v-progress-circular>
						<p class="mt-2">Procesando código...</p>
					</v-col>
				</v-row>
				
			</v-container>
		</v-card>
	</div>
</template>

<script>
	import _sPrfCountingBoxesPresentationService from "../../../services/FreshProduction/PrfCountingBoxesPresentation"
	import _servicePerson from "@/services/General/PersonService";
	import _service from "@/services/FreshProduction/PrfAssignTurnWorKerDetailService";
	import SPresentation from "@/components/Utils/SSelectPresentation";
	import _servicePresentation from "@/services/FreshProduction/PrfPresentationConfigService.js";
	import _sTurnService from "@/services/FreshProduction/PrfTurnService";
	import _sParameter from "@/services/General/ParameterService.js";

	export default {
		components: {
			SPresentation
		},
		data() {
			return {
				CbpCode: "",
				separator: "",
				aux: "",
				linePacking : 0,
				TypeDestinyTk: 1,
				TypeLineProcess: 1,
				TypeCaliber:0,
				TypeFaja:0,
				ObjPresentation:null,
				dgr: 70,
				itemsPresentation: [],
				PrcID: 0,
				processInitial:{},
				itemTurn:[],
				TypeArea: 2,
				ParamMessageCountBox: 0,
				isProcessing: false, // NUEVO: Bandera para evitar procesamiento múltiple
				pendingCodes: [], // NUEVO: Cola de códigos pendientes
			}
		},

		watch: {
			CbpCode(newValue, oldValue) {
				console.log('Código cambió:', newValue, 'anterior:', oldValue)
			}
		},

		methods: {

			loadData() {
				_servicePresentation
					.listPresentation("" ,this.$fun.getUserID())
					.then(r => {
						console.log("Item de Presentation", r.data);
						this.itemsPresentation = r.data;
					});
				this.getTypeArea(this.TypeArea);
			},

			Initialize()
			{
				let USA = this.$fun.hasSpecialPermission('USA');
				let EUR = this.$fun.hasSpecialPermission('EUR');
				let KOR = this.$fun.hasSpecialPermission('KOR');
				
				if (USA)
				{
					this.linePacking = 3;
				}
				if (EUR)
				{
					this.linePacking = 2;
				}
				if (KOR)
				{
					this.linePacking = 9;
				}
			},

			input(value)
			{
				// Opcional: Log para debugging
				console.log('Código leído:', value);
			},

			async keyupEnter() {
				// Evitar procesamiento si ya hay uno en curso
				if (this.isProcessing) {
					console.warn('Ya hay un código procesándose, agregando a cola...');
					this.pendingCodes.push(this.CbpCode);
					this.CbpCode = '';
					return;
				}

				// Validaciones iniciales
				if(this.ObjPresentation === null ){
					console.log("Presentation1",this.ObjPresentation)
					this.$fun.alert("Seleccione una Presentación", "warning");
					return;
				}

				if(this.itemTurn.length == 0){
					this.$fun.alert("Error, No hay turno activo para este destino", "warning")
					return;
				}

				if(!this.CbpCode || this.CbpCode.trim() === ''){
					console.warn('Código vacío, ignorando...');
					return;
				}

				// IMPORTANTE: Guardar el código ANTES de limpiarlo
				const currentCode = this.CbpCode;
				
				// Limpiar el input inmediatamente
				this.CbpCode = '';
				
				// Marcar como procesando
				this.isProcessing = true;

				try {
					// Procesar el código guardado
					await this.processCode(currentCode);
					
				} catch (error) {
					console.error('Error en keyupEnter:', error);
				} finally {
					// Desmarcar procesamiento
					this.isProcessing = false;
					
					// Procesar códigos pendientes si hay
					if (this.pendingCodes.length > 0) {
						const nextCode = this.pendingCodes.shift();
						this.CbpCode = nextCode;
						// Usar nextTick para que el v-model se actualice
						this.$nextTick(() => {
							this.keyupEnter();
						});
					} else {
						// Volver a enfocar el input
						this.$nextTick(() => {
							this.$refs.stext.focus();
						});
					}
				}
			},

			async processCode(code) {
				console.log('Procesando código:', code);

				let TagCount = {
					CbpID : 0,
					TypeDestiny: this.TypeDestinyTk,
					TypeLine : this.TypeLineProcess,
					TypeCaliber : this.TypeCaliber,
					TypeBelt : this.TypeFaja,
					PrcID : this.ObjPresentation,
					CbpCode: code,
					TrnID: this.itemTurn[0].TrnID,
					SecStatus : 1,
					TypeArea: this.TypeArea,
					UsrCreateID: this.$fun.getUserID()
				}

				console.log("TagCount a guardar:", TagCount);

				// Extraer DNI del código
				let CbpCodeDnI = TagCount.CbpCode;
				let dni = CbpCodeDnI.split(',')[0];
				console.log('DNI extraído:', dni);

				// Buscar persona (ahora correctamente await)
				let persona = await this.searchPerson(dni);
				
				try {
					// Guardar el código (await correcto)
					let resp = await _sPrfCountingBoxesPresentationService.save(
						TagCount,
						this.$fun.getUserID()
					);

					if (this.ParamMessageCountBox) {
						if (resp.status == 200) {
							this.$fun.alert(
								"Caja Contada Correctamente por la empacador(a) -> " +
								(persona?.NtpName ?? "") + " " + (persona?.NtpPaternalSurname ?? ""),
								"success"
							);
						} else {
							this.$fun.alert("Error al Contar la Caja", "error");
						}
					}

				} catch (err) {
					console.error('Error al guardar:', err);
					const message = err.response?.data;

					if (message) {
						this.$fun.alert(message.Message, "warning");
					} else {
						this.$fun.alert("Error en el guardado", "error");
					}
					throw err; // Re-lanzar para que sea manejado en keyupEnter
				}
			},

			changeDes(event){
				console.log("Prueba")
			},

			inputPresentation(event){
				console.log("Presentación seleccionada:", event);
				this.ObjPresentation = event;
			},

			async searchPerson(dni) {
				console.log("Buscando persona con DNI:", dni);
				try {
					const response = await _servicePerson.getNaturalPerson(
						dni,
						this.$fun.getUserID()
					);

					if (response.status === 200 && response.data) {
						return response.data;
					} else {
						return null;
					}
				} catch (err) {
					console.error('Error buscando persona:', err);
					return null;
				}
			},

			TurnActive(){
				console.log("TypeArea:", this.TypeArea);
				_sTurnService.turnActivePrf(
					{TypeArea : this.TypeArea, TypeShip: 1}, 
					this.$fun.getUserID()
				).then(r => {
					if(r.status == 200)
					{
						console.log("Turnos activos:", r.data);
						this.itemTurn = r.data;
						if(this.itemTurn.length > 0)
							this.processInitial.TrnID = this.itemTurn[0].TrnID;
					}
				});
			},

			getTypeArea(event){
				console.log("Área seleccionada:", event);
				console.log("TypeArea:", this.TypeArea);
				this.itemTurn = [];
				this.TurnActive();
			}

		},

		created () {
			_service.codigoQR(this.$fun.getUserID())
			.then(resp => {
				if(resp.status == 200){
					if(resp.data)
					{
						this.separator = resp.data[0].PrmValue;
					}
				}
			});

			_sParameter.search(
				{ PrmName: "ParamMessageCountBox"}, 
				this.$fun.getUserID()
			).then((r) => {
				this.ParamMessageCountBox = r.data.PrmValue ?? 0;
				console.log("ParamMessageCountBox:", this.ParamMessageCountBox);
			});

			this.Initialize();
			this.loadData();
		},

		mounted () {
			this.$refs.stext.focus();
		},
		
	}
</script>

<style scoped>
/* Opcional: Estilo para indicar cuando está procesando */
.v-text-field--disabled {
	opacity: 0.6;
}
</style>